import { Component } from '@angular/core';

@Component({
    selector: 'app-not-supported',
    templateUrl: './not-supported.component.html',
    styleUrls: ['./not-supported.component.scss'],
    standalone: false
})
export class NotSupportedComponent {
}
